import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useShipFroms } from './ship-froms/use-ship-froms';
import Globals from '../store/global-selectors';
import { useDeprecatedLocalStorage, FIRST_TIME_UX_ADDRESS_CACHE } from './use-local-storage';
import { emptyObject } from 'ui-components/default-props/empty';

export const AddressTypeLookup = {
  walletBilling: 'walletBilling',
  walletPickup: 'walletPickup',
  subscriptionBilling: 'subscriptionBilling',
};

const normalizeAddressName = (address) => {
  const updatedAddress = { ...address };
  if (!updatedAddress.fullName) {
    updatedAddress.fullName = updatedAddress.name;
  }
  if (!updatedAddress.name) {
    updatedAddress.name = updatedAddress.fullName;
  }
  if (!updatedAddress.firstName && !updatedAddress.lastName) {
    const [firstName, lastName] = (updatedAddress.name || '').split(' ');
    updatedAddress.firstName = firstName;
    updatedAddress.lastName = lastName;
  }
  return updatedAddress;
};

export const useFirstTimeBillingInfo = (shouldFavorPickup) => {
  const shipFroms = useShipFroms();
  const { originAddress } = shipFroms.find(({ isDefault }) => isDefault) || emptyObject;
  const { name, email } = useSelector(Globals.selectUserCurrentUserInfo);
  const [storedAddresses] = useDeprecatedLocalStorage(FIRST_TIME_UX_ADDRESS_CACHE, emptyObject);
  const { walletBilling, subscriptionBilling, walletPickup } = storedAddresses;

  const walletOrSubscription = walletBilling ?? subscriptionBilling;
  const pickupOrDefaultShipFrom = walletPickup ?? originAddress;
  const userInfoFromRegistration = { name, email };
  if (shouldFavorPickup) {
    return normalizeAddressName(pickupOrDefaultShipFrom ?? walletOrSubscription ?? userInfoFromRegistration);
  }
  return normalizeAddressName(walletOrSubscription ?? pickupOrDefaultShipFrom ?? userInfoFromRegistration);
};

export const useSaveFirstTimeBillingInfo = () => {
  const [cachedAddresses, setCachedAddresses] = useDeprecatedLocalStorage(FIRST_TIME_UX_ADDRESS_CACHE, emptyObject);
  return useCallback(
    (addressPayload) => {
      setCachedAddresses({
        ...cachedAddresses,
        ...addressPayload,
      });
    },
    [cachedAddresses, setCachedAddresses],
  );
};
